// Command-Pattern: jede Mutation ist ein Objekt mit apply(doc)/invert(doc).
// Grundlage für Undo/Redo und Autosave-Trigger.

export class AddPartCommand {
  constructor(part) {
    this.part = part
  }

  apply(doc) {
    doc.insertPart(structuredClone(this.part))
  }

  invert(doc) {
    doc.removePart(this.part.client_id)
  }
}

export class RemovePartCommand {
  constructor(clientId) {
    this.clientId = clientId
  }

  apply(doc) {
    this.removed = structuredClone(doc.getPart(this.clientId))
    doc.removePart(this.clientId)
  }

  invert(doc) {
    if (this.removed) doc.insertPart(structuredClone(this.removed))
  }
}

// Mehrere Commands als ein Undo-Schritt (z. B. Verteilen: Move + n× Add)
export class CompositeCommand {
  constructor(commands) {
    this.commands = commands
  }

  apply(doc) {
    this.commands.forEach((command) => command.apply(doc))
  }

  invert(doc) {
    ;[...this.commands].reverse().forEach((command) => command.invert(doc))
  }
}

// Mehrere Teile in einem Undo-Schritt ändern (z. B. Anker + gehefteter Anhang)
export class UpdatePartsCommand {
  constructor(updates) {
    this.updates = updates
  }

  apply(doc) {
    this.previous = this.updates.map(({ clientId, attrs }) => {
      const part = doc.getPart(clientId)
      if (!part) return { clientId, attrs: null }
      return {
        clientId,
        attrs: Object.fromEntries(Object.keys(attrs).map((key) => [key, structuredClone(part[key])]))
      }
    })
    for (const { clientId, attrs } of this.updates) doc.updatePart(clientId, structuredClone(attrs))
  }

  invert(doc) {
    for (const { clientId, attrs } of [...this.previous].reverse()) {
      if (attrs) doc.updatePart(clientId, structuredClone(attrs))
    }
  }
}

// Parametrische Variablen als Ganzes tauschen (anlegen/ändern/umbenennen/
// löschen). Zusammen mit dem UpdatePartsCommand der gebundenen Teile in einem
// CompositeCommand ergibt das EINEN Undo-Schritt — sonst liefe ein Undo die
// Teile zurück, während die Variable auf dem neuen Wert stehen bliebe.
export class SetVariablesCommand {
  constructor(variables) {
    this.variables = variables
  }

  apply(doc) {
    this.previous = structuredClone(doc.variables)
    doc.setVariables(structuredClone(this.variables))
  }

  invert(doc) {
    if (this.previous) doc.setVariables(structuredClone(this.previous))
  }
}

export class UpdatePartCommand {
  constructor(clientId, attrs) {
    this.clientId = clientId
    this.attrs = attrs
  }

  apply(doc) {
    const part = doc.getPart(this.clientId)
    if (!part) return
    this.previous = Object.fromEntries(
      Object.keys(this.attrs).map((key) => [key, structuredClone(part[key])])
    )
    doc.updatePart(this.clientId, structuredClone(this.attrs))
  }

  invert(doc) {
    if (this.previous) doc.updatePart(this.clientId, structuredClone(this.previous))
  }
}
